import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { BaseWebApiService } from './base-web-api-service';
import { CodiceFiscale, WebApiRequest, WebApiResponse } from '../models'

@Injectable()
export class GenericService {
    private baseUrl: string;

    constructor(private baseService: BaseWebApiService) {
        this.baseUrl = baseService.URL_REST_PATH + 'common/';  // URL to web api;
    }

    calcolaCodiceFiscale(codiceFiscale: CodiceFiscale): Promise<WebApiResponse<string>> {
        let request: WebApiRequest<CodiceFiscale> = new WebApiRequest<CodiceFiscale>();
        request.data = codiceFiscale;
        return this.baseService.post(this.baseUrl + "calcolaCodiceFiscale", request).then(p => {
            let response: WebApiResponse<string> = p as WebApiResponse<string>;
            return response;
        });
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/services/generic.service.ts